// Trilingual legal content for B.health (operated by HFM SRL).
// Each section: { h: heading, p: [paragraphs]. A paragraph starting with "• " is rendered as a bullet. }

const COMPANY = {
  legal_name: "HFM SRL",
  brand: "B.health®",
  address: "Avenue de la Basilique 14, 1082 Berchem-Sainte-Agathe, Belgique",
  bce: "0651.880.679",
  vat: "BE 0651.880.679",
  email: "sante@bhealth.be",
  phone: "0493 33 33 62",
  publisher: "Jean-Luc Van Cappel",
};

export const LEGAL_NOTICE = {
  fr: {
    title: "Mentions légales",
    updated: "Dernière mise à jour : juin 2026",
    sections: [
      {
        h: "Éditeur du site",
        p: [
          `Le présent site est édité par ${COMPANY.legal_name}, exploitant la marque ${COMPANY.brand}.`,
          `Siège social : ${COMPANY.address}`,
          `Numéro d'entreprise (BCE) : ${COMPANY.bce}`,
          `Numéro de TVA : ${COMPANY.vat}`,
          `Email : ${COMPANY.email} — Téléphone : ${COMPANY.phone}`,
          `Responsable de la publication : ${COMPANY.publisher}`,
        ],
      },
      {
        h: "Hébergement",
        p: [
          "Hébergement de la messagerie : OVH SAS, 2 rue Kellermann, 59100 Roubaix, France.",
          "Hébergement du site web : prestataire technique d'hébergement de l'application, serveurs situés dans l'Union européenne. Les coordonnées complètes de l'hébergeur peuvent être obtenues sur simple demande à l'adresse de contact ci-dessus.",
        ],
      },
      {
        h: "Propriété intellectuelle",
        p: [
          `L'ensemble des contenus présents sur ce site (textes, marques, logos, visuels, structure) est la propriété de ${COMPANY.legal_name} ou de ses partenaires et est protégé par le droit applicable. Toute reproduction ou réutilisation sans autorisation préalable est interdite.`,
        ],
      },
      {
        h: "Avertissement — caractère non médical",
        p: [
          "Le questionnaire et le « Profil Restart » proposés sur ce site constituent une orientation générale liée à l'activité physique. Ils ne constituent pas un avis, un diagnostic ou un traitement médical et ne remplacent en aucun cas la consultation d'un professionnel de santé.",
        ],
      },
      {
        h: "Responsabilité",
        p: [
          `${COMPANY.legal_name} s'efforce d'assurer l'exactitude des informations diffusées mais ne peut être tenue responsable des erreurs, omissions ou de l'indisponibilité temporaire du site.`,
        ],
      },
    ],
  },
  en: {
    title: "Legal notice",
    updated: "Last updated: June 2026",
    sections: [
      {
        h: "Website publisher",
        p: [
          `This website is published by ${COMPANY.legal_name}, operating the ${COMPANY.brand} brand.`,
          `Registered office: ${COMPANY.address}`,
          `Company number (BCE): ${COMPANY.bce}`,
          `VAT number: ${COMPANY.vat}`,
          `Email: ${COMPANY.email} — Phone: ${COMPANY.phone}`,
          `Publication manager: ${COMPANY.publisher}`,
        ],
      },
      {
        h: "Hosting",
        p: [
          "Email hosting: OVH SAS, 2 rue Kellermann, 59100 Roubaix, France.",
          "Website hosting: the application's technical hosting provider, with servers located in the European Union. Full hosting details are available on request at the contact address above.",
        ],
      },
      {
        h: "Intellectual property",
        p: [
          `All content on this site (text, trademarks, logos, visuals, structure) is the property of ${COMPANY.legal_name} or its partners and is protected by applicable law. Any reproduction or reuse without prior authorisation is prohibited.`,
        ],
      },
      {
        h: "Disclaimer — non-medical nature",
        p: [
          "The questionnaire and the \"Restart Profile\" offered on this site provide general guidance related to physical activity. They do not constitute medical advice, diagnosis or treatment and are no substitute for consulting a healthcare professional.",
        ],
      },
      {
        h: "Liability",
        p: [
          `${COMPANY.legal_name} strives to ensure the accuracy of the information published but cannot be held liable for errors, omissions or temporary unavailability of the site.`,
        ],
      },
    ],
  },
  nl: {
    title: "Wettelijke vermeldingen",
    updated: "Laatst bijgewerkt: juni 2026",
    sections: [
      {
        h: "Uitgever van de website",
        p: [
          `Deze website wordt uitgegeven door ${COMPANY.legal_name}, dat het merk ${COMPANY.brand} exploiteert.`,
          `Maatschappelijke zetel: ${COMPANY.address}`,
          `Ondernemingsnummer (KBO): ${COMPANY.bce}`,
          `Btw-nummer: ${COMPANY.vat}`,
          `E-mail: ${COMPANY.email} — Telefoon: ${COMPANY.phone}`,
          `Verantwoordelijke uitgever: ${COMPANY.publisher}`,
        ],
      },
      {
        h: "Hosting",
        p: [
          "E-mailhosting: OVH SAS, 2 rue Kellermann, 59100 Roubaix, Frankrijk.",
          "Websitehosting: de technische hostingprovider van de applicatie, met servers in de Europese Unie. Volledige hostinggegevens zijn op verzoek beschikbaar via het bovenstaande contactadres.",
        ],
      },
      {
        h: "Intellectuele eigendom",
        p: [
          `Alle inhoud op deze site (teksten, merken, logo's, beelden, structuur) is eigendom van ${COMPANY.legal_name} of haar partners en wordt beschermd door het toepasselijke recht. Elke reproductie of hergebruik zonder voorafgaande toestemming is verboden.`,
        ],
      },
      {
        h: "Waarschuwing — niet-medisch karakter",
        p: [
          "De vragenlijst en het \"Restart-profiel\" op deze site bieden algemene oriëntatie rond lichaamsbeweging. Ze vormen geen medisch advies, diagnose of behandeling en vervangen geenszins een consult bij een zorgverlener.",
        ],
      },
      {
        h: "Aansprakelijkheid",
        p: [
          `${COMPANY.legal_name} streeft naar de juistheid van de gepubliceerde informatie maar kan niet aansprakelijk worden gesteld voor fouten, weglatingen of tijdelijke onbeschikbaarheid van de site.`,
        ],
      },
    ],
  },
};

export const PRIVACY = {
  fr: {
    title: "Politique de confidentialité",
    updated: "Dernière mise à jour : juin 2026",
    sections: [
      {
        h: "1. Responsable du traitement",
        p: [
          `${COMPANY.legal_name} (marque ${COMPANY.brand}), ${COMPANY.address}, est responsable du traitement de vos données personnelles.`,
          `Contact pour toute question relative à vos données : ${COMPANY.email} — ${COMPANY.phone}.`,
        ],
      },
      {
        h: "2. Données collectées",
        p: [
          "• Données d'identité et de contact : prénom, nom, adresse email, téléphone, code postal.",
          "• Réponses au questionnaire : objectifs, freins, niveau d'activité, tranche d'âge, disponibilités et préférences (données non médicales).",
          "• Données techniques d'origine de visite : source/UTM et site référent, afin de mesurer l'efficacité de nos actions.",
        ],
      },
      {
        h: "3. Finalités",
        p: [
          "• Établir et vous transmettre votre Profil Restart personnalisé.",
          "• Vous recontacter dans le cadre d'une proposition d'accompagnement (si vous y avez consenti).",
          "• Qualifier et suivre votre demande, et réaliser des statistiques internes.",
        ],
      },
      {
        h: "4. Base légale",
        p: [
          "Le traitement repose sur votre consentement (art. 6.1.a du RGPD), recueilli via la case à cocher du formulaire. Vous pouvez retirer ce consentement à tout moment.",
        ],
      },
      {
        h: "5. Traitement automatisé et intelligence artificielle",
        p: [
          "Pour personnaliser la description de votre profil, vos réponses sont traitées par un service d'intelligence artificielle (Anthropic, modèle Claude). Ce traitement ne donne lieu à aucune décision automatisée produisant des effets juridiques à votre égard. Aucune donnée de santé médicale n'est traitée : le questionnaire est de nature non médicale.",
        ],
      },
      {
        h: "6. Destinataires et partage des données",
        p: [
          `Vos données sont accessibles à l'équipe de ${COMPANY.legal_name} / ${COMPANY.brand} en charge du suivi.`,
          "• Prestataires techniques agissant comme sous-traitants : hébergeur de messagerie (OVH SAS, France) et fournisseur du service d'IA (Anthropic).",
          "• Partenaires commerciaux : vos données peuvent être partagées avec les partenaires commerciaux de B.health dans le cadre de propositions d'accompagnement. Vous pouvez vous y opposer à tout moment via l'adresse de contact.",
        ],
      },
      {
        h: "7. Transferts hors Union européenne",
        p: [
          "Lorsque des données sont traitées par des prestataires situés hors de l'Union européenne (notamment pour le service d'IA), ces transferts sont encadrés par des garanties appropriées, telles que les clauses contractuelles types de la Commission européenne.",
        ],
      },
      {
        h: "8. Durée de conservation",
        p: [
          "Vos données sont conservées tant que vous n'avez pas exercé votre droit de rétractation (retrait du consentement) ou demandé leur suppression. À réception d'une telle demande, vos données sont supprimées ou anonymisées dans les meilleurs délais.",
        ],
      },
      {
        h: "9. Vos droits",
        p: [
          "Conformément au RGPD, vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité, ainsi que du droit de retirer votre consentement à tout moment.",
          `Pour exercer ces droits : ${COMPANY.email}.`,
          "Vous avez également le droit d'introduire une réclamation auprès de l'Autorité de protection des données (APD) : Rue de la Presse 35, 1000 Bruxelles — contact@apd-gba.be.",
        ],
      },
      {
        h: "10. Cookies et stockage local",
        p: [
          "Ce site utilise uniquement le stockage local de votre navigateur à des fins strictement fonctionnelles : mémorisation de la langue choisie et mesure de la source de visite. Aucun cookie publicitaire ou de traçage tiers n'est déposé.",
        ],
      },
      {
        h: "11. Sécurité",
        p: [
          "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données (accès restreint à l'espace équipe, connexions chiffrées, authentification sécurisée).",
        ],
      },
    ],
  },
  en: {
    title: "Privacy policy",
    updated: "Last updated: June 2026",
    sections: [
      {
        h: "1. Data controller",
        p: [
          `${COMPANY.legal_name} (${COMPANY.brand} brand), ${COMPANY.address}, is the controller of your personal data.`,
          `Contact for any data-related question: ${COMPANY.email} — ${COMPANY.phone}.`,
        ],
      },
      {
        h: "2. Data collected",
        p: [
          "• Identity and contact data: first name, last name, email address, phone, postal code.",
          "• Questionnaire answers: goals, barriers, activity level, age range, availability and preferences (non-medical data).",
          "• Technical visit-origin data: source/UTM and referring site, to measure the effectiveness of our actions.",
        ],
      },
      {
        h: "3. Purposes",
        p: [
          "• Build and send you your personalised Restart Profile.",
          "• Contact you regarding a support proposal (if you consented).",
          "• Qualify and follow up on your request, and produce internal statistics.",
        ],
      },
      {
        h: "4. Legal basis",
        p: [
          "Processing is based on your consent (Art. 6.1.a GDPR), collected via the form checkbox. You may withdraw this consent at any time.",
        ],
      },
      {
        h: "5. Automated processing and artificial intelligence",
        p: [
          "To personalise your profile description, your answers are processed by an AI service (Anthropic, Claude model). This processing does not result in any automated decision producing legal effects concerning you. No medical health data is processed: the questionnaire is non-medical.",
        ],
      },
      {
        h: "6. Recipients and data sharing",
        p: [
          `Your data is accessible to the ${COMPANY.legal_name} / ${COMPANY.brand} team in charge of follow-up.`,
          "• Technical providers acting as processors: email host (OVH SAS, France) and AI service provider (Anthropic).",
          "• Commercial partners: your data may be shared with B.health's commercial partners in the context of support proposals. You may object at any time via the contact address.",
        ],
      },
      {
        h: "7. Transfers outside the European Union",
        p: [
          "Where data is processed by providers located outside the EU (in particular for the AI service), such transfers are governed by appropriate safeguards, such as the European Commission's standard contractual clauses.",
        ],
      },
      {
        h: "8. Retention period",
        p: [
          "Your data is kept until you exercise your right of withdrawal (consent withdrawal) or request its deletion. Upon such a request, your data is deleted or anonymised as soon as possible.",
        ],
      },
      {
        h: "9. Your rights",
        p: [
          "Under the GDPR, you have the rights of access, rectification, erasure, restriction, objection and portability, as well as the right to withdraw your consent at any time.",
          `To exercise these rights: ${COMPANY.email}.`,
          "You also have the right to lodge a complaint with the Belgian Data Protection Authority (APD/GBA): Rue de la Presse 35, 1000 Brussels — contact@apd-gba.be.",
        ],
      },
      {
        h: "10. Cookies and local storage",
        p: [
          "This site only uses your browser's local storage for strictly functional purposes: remembering the chosen language and measuring the visit source. No third-party advertising or tracking cookies are set.",
        ],
      },
      {
        h: "11. Security",
        p: [
          "We implement appropriate technical and organisational measures to protect your data (restricted team-area access, encrypted connections, secure authentication).",
        ],
      },
    ],
  },
  nl: {
    title: "Privacybeleid",
    updated: "Laatst bijgewerkt: juni 2026",
    sections: [
      {
        h: "1. Verwerkingsverantwoordelijke",
        p: [
          `${COMPANY.legal_name} (merk ${COMPANY.brand}), ${COMPANY.address}, is verantwoordelijk voor de verwerking van uw persoonsgegevens.`,
          `Contact voor vragen over uw gegevens: ${COMPANY.email} — ${COMPANY.phone}.`,
        ],
      },
      {
        h: "2. Verzamelde gegevens",
        p: [
          "• Identiteits- en contactgegevens: voornaam, naam, e-mailadres, telefoon, postcode.",
          "• Antwoorden op de vragenlijst: doelen, drempels, activiteitsniveau, leeftijdscategorie, beschikbaarheid en voorkeuren (niet-medische gegevens).",
          "• Technische gegevens over de bezoekherkomst: bron/UTM en verwijzende site, om de doeltreffendheid van onze acties te meten.",
        ],
      },
      {
        h: "3. Doeleinden",
        p: [
          "• Uw gepersonaliseerde Restart-profiel opstellen en bezorgen.",
          "• U contacteren in het kader van een begeleidingsvoorstel (indien u daarmee hebt ingestemd).",
          "• Uw aanvraag kwalificeren en opvolgen, en interne statistieken opstellen.",
        ],
      },
      {
        h: "4. Rechtsgrond",
        p: [
          "De verwerking is gebaseerd op uw toestemming (art. 6.1.a AVG), verkregen via het selectievakje op het formulier. U kunt deze toestemming op elk moment intrekken.",
        ],
      },
      {
        h: "5. Geautomatiseerde verwerking en artificiële intelligentie",
        p: [
          "Om uw profielbeschrijving te personaliseren, worden uw antwoorden verwerkt door een AI-dienst (Anthropic, model Claude). Deze verwerking leidt niet tot een geautomatiseerde beslissing met rechtsgevolgen voor u. Er worden geen medische gezondheidsgegevens verwerkt: de vragenlijst is niet-medisch.",
        ],
      },
      {
        h: "6. Ontvangers en gegevensdeling",
        p: [
          `Uw gegevens zijn toegankelijk voor het ${COMPANY.legal_name} / ${COMPANY.brand}-team dat instaat voor de opvolging.`,
          "• Technische dienstverleners als verwerkers: e-mailhost (OVH SAS, Frankrijk) en AI-dienstverlener (Anthropic).",
          "• Commerciële partners: uw gegevens kunnen worden gedeeld met de commerciële partners van B.health in het kader van begeleidingsvoorstellen. U kunt zich hiertegen op elk moment verzetten via het contactadres.",
        ],
      },
      {
        h: "7. Doorgifte buiten de Europese Unie",
        p: [
          "Wanneer gegevens worden verwerkt door dienstverleners buiten de EU (met name voor de AI-dienst), zijn deze doorgiftes onderworpen aan passende waarborgen, zoals de modelcontractbepalingen van de Europese Commissie.",
        ],
      },
      {
        h: "8. Bewaartermijn",
        p: [
          "Uw gegevens worden bewaard zolang u uw herroepingsrecht (intrekking van de toestemming) niet hebt uitgeoefend of de verwijdering ervan niet hebt gevraagd. Na ontvangst van zo'n verzoek worden uw gegevens zo snel mogelijk verwijderd of geanonimiseerd.",
        ],
      },
      {
        h: "9. Uw rechten",
        p: [
          "Conform de AVG beschikt u over het recht op inzage, rectificatie, wissing, beperking, bezwaar en overdraagbaarheid, evenals het recht om uw toestemming op elk moment in te trekken.",
          `Om deze rechten uit te oefenen: ${COMPANY.email}.`,
          "U hebt ook het recht om een klacht in te dienen bij de Gegevensbeschermingsautoriteit (GBA): Drukpersstraat 35, 1000 Brussel — contact@apd-gba.be.",
        ],
      },
      {
        h: "10. Cookies en lokale opslag",
        p: [
          "Deze site gebruikt uitsluitend de lokale opslag van uw browser voor strikt functionele doeleinden: het onthouden van de gekozen taal en het meten van de bezoekbron. Er worden geen reclame- of trackingcookies van derden geplaatst.",
        ],
      },
      {
        h: "11. Beveiliging",
        p: [
          "Wij nemen passende technische en organisatorische maatregelen om uw gegevens te beschermen (beperkte toegang tot de teamruimte, versleutelde verbindingen, beveiligde authenticatie).",
        ],
      },
    ],
  },
};
